import { Pill as CXPill } from '@sanlamcx/react-ui-next-pill';

export const Pill = CXPill;
